
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import EditButton from '../../buttons/EditButton';

class TabSection extends PureComponent {
  static defaultProps = {
    editMode: false,
    //order:1,
    title: " ",
    //enabled:false,
    Loading: false,
  };
  constructor(props) {
    super(props);
  }


  render() {
    //const isEditMode = (this.props.editMode ? " edit-mode" : "");
    const isLoading = (this.props.Loading ? " isLoading" : "");

    return (
      <div className={"tab-section"}>
        <div className={"tab-section-body" + isLoading}>
          {this.props.children}
        </div>
      </div>
    );
    // if(this.props.enabled || this.props.editMode)
    //   	return(
    //   		 	 <div className={"tab-section"+ (isEditMode && " edit-mode" )}>
    //            <div className="tab-section-header">
    //             <span className="tab-section--number">{this.props.order}</span> 
    //             <span className="tab-section--title">{this.props.title}</span> 
    //             { this.props.editMode && <span className="tab-section--edit" onClick={this.props.EditClick}><EditButton/></span> }
    //            </div>
    //            <div className={"tab-section-body"+isLoading}>
    //             {this.props.children}
    //            </div>
    //          </div>
    // 		);
    // else
    //   return(
    //          <div className={"tab-section section-disabled"}>
    //            <div className="tab-section-header">
    //             <span className="tab-section--number">{this.props.order}</span> 
    //             <span className="tab-section--title">{this.props.title}</span> 
    //             </div>
    //          </div>
    //     );
  }
}
export default TabSection;
